export async function getCategories(questionPostsData) {
    try {
        const questionPosts = questionPostsData.data;

        const data = [{
                title: questionPosts[9].acf.section_title,
                category: {
                    id: 1,
                    class: '__workint',
                    title: 'Well-paced Work'
                },
                total: 12,
                score: null,
                subQuestions: [{
                        id: 1,
                        title: questionPosts[9].acf.questions[0].question,
                        answers: [{
                                title: 'All the time',
                                weight: 0
                            },
                            {
                                title: 'Almost all the time',
                                weight: 1
                            },
                            {
                                title: 'Around three quarters of the time',
                                weight: 2
                            },
                            {
                                title: 'Around half the time',
                                weight: 3
                            },
                            {
                                title: 'Around a quarter of the time',
                                weight: 4
                            },
                            {
                                title: 'Almost never',
                                weight: 5
                            },
                            {
                                title: 'Never',
                                weight: 6
                            }
                        ],
                        answer: null,
                        score: null
                    },
                    {
                        id: 2,
                        title: questionPosts[9].acf.questions[1].question,
                        answers: [{
                                title: 'All the time',
                                weight: 0
                            },
                            {
                                title: 'Almost all the time',
                                weight: 1
                            },
                            {
                                title: 'Around three quarters of the time',
                                weight: 2
                            },
                            {
                                title: 'Around half the time',
                                weight: 3
                            },
                            {
                                title: 'Around a quarter of the time',
                                weight: 4
                            },
                            {
                                title: 'Almost never',
                                weight: 5
                            },
                            {
                                title: 'Never',
                                weight: 6
                            }
                        ],
                        answer: null,
                        score: null
                    }
                ]
            },
            {
                title: questionPosts[8].acf.section_title,
                category: {
                    id: 2,
                    class: '__taskdisc',
                    title: 'Task Discretion'
                },
                total: 6,
                score: null,
                subQuestions: [{
                        id: 1,
                        title: questionPosts[8].acf.questions[0].question,
                        answers: [{
                                title: 'A great deal',
                                weight: 3
                            },
                            {
                                title: 'A fair amount',
                                weight: 2
                            },
                            {
                                title: 'Not much',
                                weight: 1
                            },
                            {
                                title: 'None at all',
                                weight: 0
                            }
                        ],
                        answer: null,
                        score: null
                    },
                    {
                        id: 2,
                        title: questionPosts[8].acf.questions[1].question,
                        answers: [{
                                title: 'A great deal',
                                weight: 3
                            },
                            {
                                title: 'A fair amount',
                                weight: 2
                            },
                            {
                                title: 'Not much',
                                weight: 1
                            },
                            {
                                title: 'None at all',
                                weight: 0
                            }
                        ],
                        answer: null,
                        score: null
                    }
                ]
            },
            {
                title: questionPosts[7].acf.section_title,
                category: {
                    id: 3,
                    class: '__workervoi',
                    title: 'Worker Voice'
                },
                total: 3,
                score: null,
                dynamic: true,
                subQuestions: [{
                        id: 1,
                        title: questionPosts[7].acf.questions[0].question,
                        answers: [{
                                title: 'Yes',
                                weight: 0
                            },
                            {
                                title: 'No',
                                weight: 0
                            },
                            {
                                title: 'It depends',
                                weight: 1
                            }
                        ],
                        answer: null,
                        score: null
                    },
                    {
                        id: 2,
                        title: questionPosts[7].acf.questions[1].question,
                        answers: [{
                                title: 'A great deal',
                                weight: 3
                            },
                            {
                                title: 'Quite a lot',
                                weight: 2
                            },
                            {
                                title: 'Just a little',
                                weight: 1
                            }
                        ],
                        answer: null,
                        score: 0
                    }
                ]
            },
            {
                title: questionPosts[6].acf.section_title,
                category: {
                    id: 4,
                    class: '__autonomy',
                    title: 'Autonomy Over Working Time'
                },
                total: 3,
                score: null,
                subQuestions: [{
                    id: 1,
                    title: questionPosts[6].acf.questions[0].question,
                    answers: [{
                            title: 'Strongly agree',
                            weight: 3
                        },
                        {
                            title: 'Agree',
                            weight: 2
                        },
                        {
                            title: 'Disagree',
                            weight: 1
                        },
                        {
                            title: 'Strongly disagree',
                            weight: 0
                        }
                    ],
                    answer: null,
                    score: null
                }]
            },
            {
                title: questionPosts[5].acf.section_title,
                category: {
                    id: 5,
                    class: '__worklife',
                    title: 'Work-Life Balance'
                },
                total: 3,
                score: null,
                subQuestions: [{
                    id: 1,
                    title: questionPosts[5].acf.questions[0].question,
                    answers: [{
                            title: 'Not difficult at all',
                            weight: 3
                        },
                        {
                            title: 'Not too difficult',
                            weight: 2
                        },
                        {
                            title: 'Somewhat difficult',
                            weight: 1
                        },
                        {
                            title: 'Very difficult',
                            weight: 0
                        }
                    ],
                    answer: null,
                    score: null
                }]
            },
            {
                title: questionPosts[4].acf.section_title,
                category: {
                    id: 6,
                    class: '__managerial',
                    title: 'Managerial Support'
                },
                total: 8,
                score: null,
                subQuestions: [{
                        id: 1,
                        title: questionPosts[4].acf.questions[0].question,
                        answers: [{
                                title: 'A great deal of help',
                                weight: 4
                            },
                            {
                                title: 'Quite a lot of help',
                                weight: 3
                            },
                            {
                                title: 'Of some help',
                                weight: 2
                            },
                            {
                                title: 'A little help',
                                weight: 1
                            },
                            {
                                title: 'Of no help at all',
                                weight: 0
                            }
                        ],
                        answer: null,
                        score: null
                    },
                    {
                        id: 2,
                        title: questionPosts[4].acf.questions[1].question,
                        answers: [{
                                title: 'A great deal of help',
                                weight: 4
                            },
                            {
                                title: 'Quite a lot of help',
                                weight: 3
                            },
                            {
                                title: 'Of some help',
                                weight: 2
                            },
                            {
                                title: 'A little help',
                                weight: 1
                            },
                            {
                                title: 'Of no help at all',
                                weight: 0
                            }
                        ],
                        answer: null,
                        score: null
                    }
                ]
            },
            {
                title: questionPosts[3].acf.section_title,
                category: {
                    id: 7,
                    class: '__required',
                    title: 'Required Learning'
                },
                total: 6,
                score: null,

                subQuestions: [{
                        id: 1,
                        title: questionPosts[3].acf.questions[0].question,
                        answers: [{
                                title: 'Strongly agree',
                                weight: 3
                            },
                            {
                                title: 'Agree',
                                weight: 2
                            },
                            {
                                title: 'Disagree',
                                weight: 1
                            },
                            {
                                title: 'Strongly disagree',
                                weight: 0
                            }
                        ],
                        answer: null,
                        score: null
                    },
                    {
                        id: 2,
                        title: questionPosts[3].acf.questions[1].question,
                        answers: [{
                                title: 'Strongly agree',
                                weight: 3
                            },
                            {
                                title: 'Agree',
                                weight: 2
                            },
                            {
                                title: 'Disagree',
                                weight: 1
                            },
                            {
                                title: 'Strongly disagree',
                                weight: 0
                            }
                        ],
                        answer: null,
                        score: null
                    }
                ]
            },
            {
                title: questionPosts[2].acf.section_title,
                category: {
                    id: 8,
                    class: '__promotion',
                    title: 'Promotion Prospects'
                },
                total: 4,
                score: null,
                subQuestions: [{
                    id: 1,
                    title: questionPosts[2].acf.questions[0].question,
                    answers: [{
                            title: '100% definite',
                            weight: 4
                        },
                        {
                            title: '75% high chance',
                            weight: 3
                        },
                        {
                            title: '50% fifty-fifty',
                            weight: 2
                        },
                        {
                            title: '25% low chance',
                            weight: 1
                        },
                        {
                            title: '0% no chance at all',
                            weight: 0
                        }
                    ],
                    answer: null,
                    score: null
                }]
            },
            {
                title: questionPosts[1].acf.section_title,
                category: {
                    id: 9,
                    class: '__jobinsec',
                    title: 'Job Security'
                },
                total: 5,
                score: null,
                dynamic: true,
                subQuestions: [{
                        id: 1,
                        title: questionPosts[1].acf.questions[0].question,
                        answers: [{
                                title: 'Yes',
                                weight: 0
                            },
                            {
                                title: 'No',
                                weight: 5
                            }
                        ],
                        answer: null,
                        score: null
                    },
                    {
                        id: 2,
                        title: questionPosts[1].acf.questions[1].question,
                        answers: [{
                                title: 'Very likely',
                                weight: 0
                            },
                            {
                                title: 'Quite likely',
                                weight: 1
                            },
                            {
                                title: 'Evens',
                                weight: 2
                            },
                            {
                                title: 'Quite unlikely',
                                weight: 3
                            },
                            {
                                title: 'Very unlikely',
                                weight: 4
                            }
                        ],
                        answer: null,
                        score: 0
                    },
                    {
                        id: 3,
                        title: questionPosts[1].acf.questions[2].question,
                        answers: [
                            {
                                title: 'Very anxious',
                                weight: 0,
                            },
                            {
                                title: 'Fairly anxious',
                                weight: 1,
                            },
                            {
                                title: 'Not very anxious',
                                weight: 2,
                            },
                            {
                                title: 'Not anxious at all',
                                weight: 3,
                            },
                        ],
                        answer: null,
                        score: null,
                    }
                ],
            },
            {
                title: questionPosts[0].acf.section_title,
                category: {
                    id: 10,
                    class: '__pay',
                    title: 'Pay'
                },
                total: 5,
                score: null,
                subQuestions: [{
                    id: 1,
                    title: questionPosts[0].acf.questions[0].question,
                    subtitle: 'If your pay before tax changes from week to week, think about what you get paid per hour. If you work part-time and are paid annually think about what you would get paid were you to work full-time.',
                    answers: [{
                            title: '£7.49 an hour or less (£14,600 per year or less for a full-time job)',
                            weight: 0
                        },
                        {
                            title: '£7.50 - £10.00 an hour (£14,601 - £19,500 per year for a full-time job)',
                            weight: 1
                        },
                        {
                            title: '£10.01 - £15.00 an hour (£19,501 - £29,250 per year for a full-time job)',
                            weight: 2
                        },
                        {
                            title: '£15.01 - £21.00 an hour (£29,251 - £40,950 per year for a full-time job)',
                            weight: 3
                        },
                        {
                            title: '£21.01 - £31.00 an hour (£40,951 - £60,450 per year for a full-time job)',
                            weight: 4
                        },
                        {
                            title: '£31.01 an hour and above (£60,451 per year or over for a full-time job)',
                            weight: 5
                        }

                    ],
                    answer: null,
                    score: null
                }]
            }
        ];

        return data;
    } catch (e) {
        console.log(e);
    }
}

export function getSOC(jobTitle) {
    // get soc based on jobTitle
}


// WEBPACK FOOTER //
// ./src/categories.js